<template>
  <div class="right-nav-box">
    <!-- 微信公众号 -->
    <el-popover placement="left" width="300" trigger="hover">
      <div slot="reference" class="nav-item column-center border-bm cur-point" @mouseover="mouseIn(0)"
        @mouseleave="mouseOut">
        <img v-if="activeIndex !== 0" src="../../assets/images/wx-icon.png" alt="" />
        <img v-if="activeIndex == 0" src="../../assets/images/wx-icon-active.png" alt="" />
        <span class="mt10 fs-12">{{$t('Handbook.text19')}}</span>
      </div>
      <div class="qCode-box row-center">
        <img style="width: 400px;height: 400px;" :src="baseUrl + sysInfo[0].weChatImg" alt="" />
      </div>
    </el-popover>
    <!-- 小程序 -->
    <el-popover placement="left" width="300" trigger="hover">
      <div slot="reference" class="nav-item column-center border-bm cur-point" @mouseover="mouseIn(1)"
        @mouseleave="mouseOut">
        <img v-if="activeIndex !== 1" src="../../assets/images/mini-program-icon.png" alt="" />
        <img v-if="activeIndex == 1" src="../../assets/images/mini-program-icon-active.png" alt="" />
        <span class="mt10 fs-12">{{$t('Handbook.text20')}}</span>
      </div>
      <div class="qCode-box row-center">
        <img style="width: 400px;height: 400px;" :src="baseUrl + sysInfo[0].appImg" alt="" />
      </div>
    </el-popover>
    <!-- 联系客服 -->
    <el-popover placement="left" width="210" trigger="hover">
      <div slot="reference" class="nav-item column-center border-bm cur-point" @mouseover="mouseIn(2)"
        @mouseleave="mouseOut">
        <img v-if="activeIndex !== 2" src="../../assets/images/linkman-icon.png" alt="" />
        <img v-if="activeIndex == 2" src="../../assets/images/linkman-icon-active.png" alt="" />
        <span class="mt10 fs-12">{{$t('Handbook.text21')}}</span>
      </div>
      <div class="row-center fs-28">
        {{ sysInfo[0].phonenumber }}
      </div>
    </el-popover>
    <!-- 反馈意见 -->
    <div class="nav-item column-center cur-point" @mouseover="mouseIn(3)" @mouseleave="mouseOut"
      @click="dialogShow = true">
      <img v-if="activeIndex !== 3" src="../../assets/images/opinion-icon.png" alt="" />
      <img v-if="activeIndex == 3" src="../../assets/images/opinion-icon-active.png" alt="" />
      <span class="mt10 fs-12">{{$t('Handbook.text22')}}</span>
    </div>
    <!-- 返回顶部 -->
    <div class="nav-item column-center mt10 cur-point" @click="returnTop">
      <img src="../../assets/images/return-top-icon.png" alt="" />
      <span class="mt10 fs-12">{{$t('Handbook.text23')}}</span>
    </div>
    <!-- 意见反馈对话框 -->
    <feedback :is-show="dialogShow" @close="dialogShow = false" />
  </div>
</template>
<script>
  import {
    mapGetters
  } from "vuex";
  import feedback from "@/components/dialog/feedback";
  export default {
    components: {
      feedback,
    },
    data() {
      return {
        dialogShow: false,
        activeIndex: undefined,
        baseUrl: process.env.VUE_APP_BASE_API,
      };
    },
    computed: {
      ...mapGetters(["sysInfo"]),
    },
    created() {},
    methods: {
      returnTop() {
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
      },
      mouseIn(i) {
        this.activeIndex = i;
      },
      mouseOut() {
        this.activeIndex = undefined;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .right-nav-box {
    width: 80px;

    .qCode-box {
      width: 300px;
      height: 300px;

      img {
        width: 180px;
        height: 180px;
      }
    }

    .nav-item {
      width: 80px;
      height: 80px;
      background: #fff;
    }

    .border-bm {
      border-bottom: 1px solid #ddd;
    }
  }
</style>